import { FC, useMemo, useCallback, MouseEvent as ReactMouseEvent } from 'react'
import styles from 'components/features/future/FutureLayerPast/PastCard/PastCard.styl'
import Button, { ButtonTheme } from 'components/features/pfm/Button/Button'
import { useForm, FormProvider } from 'react-hook-form'
import { PastCardValues } from 'components/features/future/FutureLayerPast/types'

type PastCardProps = {
  action: string
  actionTheme?: ButtonTheme
  onAction: (values: PastCardValues) => void
}
export const PastCard: FC<PastCardProps> = (props) => {
  const { children, action, onAction, actionTheme = 'blue' } = props

  const formContext = useForm({
    defaultValues: {
      set_income: true,
      set_marital_status: true,
      addIncomeChangeEvent: true,
    },
    shouldUnregister: true,
  })
  const { handleSubmit } = formContext

  const hooksFormHandler = useMemo(() => handleSubmit((formData) => {
    onAction(formData)
  }), [handleSubmit, onAction])

  const handleFormSubmit = useCallback((event: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault()
    hooksFormHandler(event)
  }, [hooksFormHandler])

  return (
    <FormProvider { ...formContext }>
      <div className={ styles.content }>
        { children }
      </div>
      <Button fullWidth theme={ actionTheme } onClick={ handleFormSubmit }>{ action }</Button>
    </FormProvider>
  )
}
